import { Modal } from "antd";
import { Rule } from "antd/lib/form";
import { CoordAddress } from "components/Map/GoogleMapAutoComplete";
import { GoogleMaps } from "components/Map/GoogleMaps";
import { Coords } from "google-map-react";
import { useEffect, useRef, useState } from "react";
import { ModalStatus } from "types/modal";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true }];

export const ShopChooseAddressModal = ({
  visible,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  onClose: () => void;
  onSubmitOk: (coord: CoordAddress) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [coord, setCoord] = useState<CoordAddress>({
    lat: 0,
    lng: 0,
    address: "",
  });

  useEffect(() => {}, [visible]);

  return (
    <Modal
      onCancel={onClose}
      visible={visible}
      title={"Chọn địa chỉ"}
      style={{ top: 20, maxWidth: "100%" }}
      width={700}
      confirmLoading={loading}
      onOk={() => {
        onSubmitOk(coord);
        onClose();
      }}
    >
      <GoogleMaps onPlaceSelected={setCoord} />
    </Modal>
  );
};
